// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._102oidpf ul{margin-top:0}\n._1e0c116y{display:inline-flex}\n._1kvxu2gc ul{margin-right:var(--ds-space-100,8px)}\n._1ul91ns9{min-width:-moz-fit-content;min-width:fit-content}", ""]);
// Exports
module.exports = exports;
